import styled from 'styled-components';

export const Subtitle = styled.div`
  position: absolute;
  bottom: 4%;
  right: 4%;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.01em;
  color: #fff;
  max-width: 138px;
`;

export const SubtitleMobile = styled.div`
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.05em;
  color: #fff;
  padding: 40px 48px;
`;
